<template>
  <div class="container-fluid container-kanban">
    <div class="row no-gutters">
      <div class="col-md-12 col-lg-4 pr-lg-2">
        <pesquisar-kanban ref="pesquisa" @pesquisar="filtrar" :load="loadPedidos || emLote"/>
      </div>
      <div class="col-md-12 col-lg-8 text-right text-nowrap" v-show="emLote">
        <div class="d-flex justify-content-end">
          <button class="btn btn-outline-dark" @click="clearPesquisa()">Cancelar</button>
          <button v-if="emLote === 2" class="btn btn-info ml-2 px-4" @click="alterarEmMassa(3)">
            <span class="d-none d-md-inline-block mr-2">Despachar</span>
            <i class="fa fa-arrow-right"></i>
          </button>
          <button class="btn btn-dark ml-2 px-4" @click="alterarEmMassa(4)" v-if="emLote === 3">
            <i class="fa fa-check"></i>
            <span class="d-none d-md-inline-block ml-2">Finalizar</span>
          </button>
        </div>
      </div>
      <div class="col-md-12 col-lg-8 text-right d-none d-md-block" v-if="!emLote">
        <button class="btn btn-outline-primary" v-if="bell && bell.status" @click="pausarNotificacao()" title="Pausar som">
          <i class="fa fa-volume-mute"></i>
        </button>
        <a class="btn-piloto border bg-white text-dark ml-2" href="javascript:" v-if="showPiloto && !isRead"
           @click="togglePilotoAutomatico()" title="Habilite para aceitar os pedidos automaticamente">
          <span class="pr-1 font-weight-bold" style="font-size: 11px">Piloto automático</span>
          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="pilotoAutomatico"/>
          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!pilotoAutomatico"/>
        </a>
        <button class="btn btn-info ml-2 px-4 position-relative" title="Rotas de Entrega" @click="openMapa()">
          <i class="fa fa-map-marked-alt" style="width: 20px"></i>
        </button>
        <button class="btn btn-dark ml-2 " title="Imprimir Resumo dos Pedidos" @click="visualizarResumo()" :disabled="paLoad">
          <i class="fa fa-chart-line mr-1"></i> Resumo <span class="d-none d-sm-inline-block">diário</span>
        </button>
        <button class="btn btn-secondary ml-2" @click="$refs.manual.openPedidoManual()">
          <i class="fa fa-plus mr-1"></i> Pedido <span class="d-none d-sm-inline-block">manual</span>
        </button>
        <button class="btn btn-light ml-2" @click="modalOutros = !modalOutros" @blur="modalOutros = false" title="Abrir Menu">
          <i class="fa fa-ellipsis-v"></i>
        </button>
        <button class="btn btn-light border ml-2" @click="$emit('fecharModal')" title="Fechar" v-if="modal">
          <i class="fa fa-times"></i>
        </button>
        <div class="modal-outros" v-if="modalOutros">
          <div class="card border shadow rounded-sm">
            <a href="javascript:" class="outros-item" @mousedown="buscarPedidosFila()">
              <i class="fa fa-sync-alt mr-1" style="width: 20px"></i> Atualizar pedidos
            </a>
            <a href="javascript:" class="outros-item" @mousedown="selPedidosDespachar()">
              <i class="fa fa-arrow-right mr-1" style="width: 20px"></i> Despachar em massa
            </a>
            <a href="javascript:" class="outros-item" @mousedown="selPedidosFinalizar()">
              <i class="fa fa-check mr-1" style="width: 20px"></i> Finalizar em massa
            </a>
          </div>
        </div>
      </div>
    </div>
    <hr class="my-2">
    <div class="row no-gutters d-lg-none my-3">
      <div class="col-4 pr-1"><button :class="menu === 1 ? 'btn-secondary' : 'btn-outline-dark'" class="btn btn-block" @click="menu = 1">Novos <span v-if="aguardando.length" class="badge badge-light">{{ aguardando.length }}</span></button></div>
      <div v-if="pesquisa.status === '1'" class="col-4 pr-1"><button :class="menu === 2 ? 'btn-info' : 'btn-outline-dark'" class="btn btn-block" @click="menu = 2">Preparando</button></div>
      <div class="col-4" v-if="pesquisa.status === '1'"><button class="btn btn-block" :class="menu === 3 ? 'btn-dark' : 'btn-outline-dark'" @click="menu = 3">Despachados</button></div>
      <div class="col-4" v-if="pesquisa.status === '4'"><button class="btn btn-block" :class="menu === 4 ? 'btn-dark' : 'btn-outline-dark'" @click="menu = 4">Finalizados</button></div>
      <div v-if="pesquisa.status === '5'" class="col-4"><button :class="menu === 5 ? 'btn-secondary' : 'btn-outline-dark'" class="btn btn-block" @click="menu = 5">Cancelados</button></div>
      <div class="col-4" v-if="pesquisa.status === '6'"><button class="btn btn-block" :class="menu === 6 ? 'btn-secondary' : 'btn-outline-dark'" @click="menu = 6">Agendados</button></div>
    </div>
    <div class="row no-gutters">
      <div class="col-lg-4 pr-lg-1">
        <div class="kanban-coluna" :class="{'aberto': menu === 1}">
          <div class="kanban-col-header bg-secondary">
            <div class="text-uppercase">Novos Pedidos<span v-if="aguardando.length">: {{ aguardando.length }}</span></div>
          </div>
          <div class="kanban-col-body">
            <div class="p-2 border-bottom small d-flex align-items-center" v-if="ifood && !ifoodAtivo" style="line-height: 1rem">
              <img src="../../assets/icons/ifood.svg" class="mr-2" style="width: 24px;">
              Mantenha o Gestor Principal aberto para que os pedidos do iFood sejam sincronizados.
            </div>
            <div class="p-2 small d-flex align-items-center border-bottom" v-if="ifoodAtivo && !statusIfood">
              <img src="../../assets/icons/ifood.svg" class="mr-2" style="width: 24px">
              <div>Aguardando sincronização do iFood..</div>
            </div>
            <div v-if="pilotoAutomatico" class="bg-white text-center p-2 border-bottom">
              <i class="fa fa-robot text-secondary"></i>
              <div class="font-weight-bold">Piloto Automático</div>
              <p class="mb-0 small">
                <span v-if="paLoad">Pedidos na fila: {{ aguardando.length }}</span>
                <span v-else-if="aguardando.length">Fila pausada. <a href="javascript:" class="text-primary" @click="buscarPedidosFila(1)">Tentar novamente</a></span>
                <span v-else>Novos pedidos serão aceitos automaticamente</span>
              </p>
            </div>
            <loading style="padding-top: 42px" v-if="loadAguardando"/>
            <div class="row no-gutters">
              <div class="col-md-4 col-lg-12" v-for="(p, i) in aguardando" :key="i">
                <kanban-item :p="p" :load="paLoad || loadAcao" :nome="multiple" @abrirPedido="abrirPedido" @acaoPedido="acaoPedido"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 pr-lg-1" v-show="pesquisa.status === '1'" @drop="onDrop($event, 2)" @dragover.prevent @dragenter.prevent>
        <div class="kanban-coluna" :class="{'aberto': menu === 2}">
          <div class="kanban-col-header bg-info">
            <label v-if="emLote === 2" class="checkbox-label mb-0 pointer">
              <input :checked="selecionados.length > 0 && preparando.length === selecionados.length" class="checkbox-header mr-1" type="checkbox" @change="selPedidos(2)"> Todos
            </label>
            <div>Preparando<span v-if="preparando.length">: {{ preparando.length }}</span></div>
          </div>
          <div class="kanban-col-body">
            <span id="topPreparando"></span>
            <loading style="padding-top: 42px" v-if="loadPedidos"/>
            <div v-show="!loadPedidos">
              <div class="p-2 bg-warning text-white small d-flex align-items-center" v-if="pesquisa.ativada">
                <i class="fa fa-filter ml-1 mr-2"></i>
                <div>Filtro de pesquisa ativado</div>
                <div class="ml-auto text-nowrap"><a href="javascript:" @click="clearPesquisa()" class="text-white"><u>Limpar</u></a></div>
              </div>
              <a href="javascript:" class="text-dark text-decoration-none" @click="$refs.pesquisa.filtrarStatus('6')" v-if="agendados.length">
                <div class="mx-2 mt-2 p-2 border rounded-lg d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calendar-time" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#4B8CFA" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"/><circle cx="18" cy="18" r="4"/><path d="M15 3v4M7 3v4m-4 4h16m-1 5.496V18l1 1"/></svg>
                  <b class="ml-2 small">Agendamentos futuros</b>
                  <b class="badge badge-info ml-auto" v-if="agendados.length">{{ agendados.length }}</b>
                </div>
              </a>
              <div class="row no-gutters">
                <div class="col-sm-6 col-lg-12" v-for="(p, i) in preparando" :key="i">
                  <div class="row no-gutters align-items-center">
                    <div class="col-1 text-center pl-2" v-if="emLote === 2">
                      <input :checked="!!selecionados.find(pedido => pedido.id_pedido === p.id_pedido)" type="checkbox" @change="abrirPedido(p)">
                    </div>
                    <div class="col">
                      <kanban-item :agora="agora" :emLote="emLote" :entregadores="user.entregadores" :load="loadAcao" :nome="multiple" :p="p"
                                   @abrirPedido="abrirPedido" @escolherEntregador="escolherEntregador" @atualizar-logistica="atualizarSolicitacaoEntregador"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 pr-lg-1" v-show="pesquisa.status === '1'" @drop="onDrop($event, 3)" @dragover.prevent @dragenter.prevent>
        <div class="kanban-coluna" :class="{'aberto': menu === 3}">
          <div class="kanban-col-header bg-dark">
            <label v-if="emLote === 3" class="checkbox-label mb-0 pointer">
              <input :checked="selecionados.length > 0 && despachados.length === selecionados.length" class="checkbox-header mr-1" type="checkbox" @change="selPedidos(3)"> Todos
            </label>
            <div>Despachados<span v-if="despachados.length">: {{ despachados.length }}</span></div>
          </div>
          <div class="kanban-col-body">
            <loading style="padding-top: 42px" v-if="loadPedidos"/>
            <div v-show="!loadPedidos">
              <div class="p-2 bg-warning text-white small d-flex align-items-center" v-if="pesquisa.ativada">
                <i class="fa fa-filter ml-1 mr-2"></i>
                <div>Filtro de pesquisa ativado</div>
                <div class="ml-auto text-nowrap"><a href="javascript:" @click="clearPesquisa()" class="text-white"><u>Limpar</u></a></div>
              </div>
              <div class="row no-gutters">
                <div class="col-sm-6 col-lg-12" v-for="(p, i) in despachados" :key="i">
                  <div class="row no-gutters align-items-center">
                    <div class="col-1 text-center pl-2" v-if="emLote === 3">
                      <input :checked="!!selecionados.find(pedido => pedido.id_pedido === p.id_pedido)" type="checkbox" @change="abrirPedido(p)">
                    </div>
                    <div class="col">
                      <kanban-item :p="p" :load="loadAcao" :nome="multiple" :emLote="emLote" :entregadores="user.entregadores" @abrirPedido="abrirPedido" @finalizar="finalizarPedido" @escolherEntregador="escolherEntregador"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 px-1" v-if="pesquisa.status === '4'">
        <div class="kanban-coluna" :class="{'aberto': menu === 4}">
          <div class="kanban-col-header bg-dark">
            <div>FINALIZADOS</div>
          </div>
          <div class="kanban-col-body">
            <loading style="padding-top: 98px" v-if="loadPedidos"/>
            <div v-show="!loadPedidos">
              <div class="p-2 bg-warning text-white d-flex align-items-center small">
                <i class="fa fa-filter ml-1 mr-2"></i>
                <div>Filtro de pesquisa ativado</div>
                <div class="ml-auto text-nowrap"><a href="javascript:" @click="clearPesquisa()" class="text-white"><u>Limpar</u></a></div>
              </div>
              <div class="row no-gutters">
                <div class="col-sm-6 col-lg-12" v-for="(p, i) in pedidos" :key="i">
                  <kanban-item :p="p" :nome="multiple" :entregadores="user.entregadores" @abrirPedido="abrirPedido" @escolherEntregador="escolherEntregador"/>
                </div>
              </div>
              <div class="p-1 mt-2 border-top d-flex justify-content-between align-items-center" v-if="!loadPedidos && (pesquisa.page > 0 || pedidos.length === this.pagination)">
                <button class="btn btn-sm text-dark" @click="paginarPedidos(-1)" :disabled="pesquisa.page === 0"><i class="fa fa-angle-left"></i> Anterior</button>
                <div class="small" v-if="pesquisa.page">Pag: {{pesquisa.page + 1}}</div>
                <button class="btn btn-sm text-dark" @click="paginarPedidos(1)" :disabled="pedidos.length < this.pagination">Próxima <i class="fa fa-angle-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 px-1" v-if="pesquisa.status === '5'">
        <div class="kanban-coluna" :class="{'aberto': menu === 5}">
          <div class="kanban-col-header bg-danger">
            <div>CANCELADOS</div>
          </div>
          <div class="kanban-col-body">
            <loading style="padding-top: 48px" v-if="loadPedidos"/>
            <div v-show="!loadPedidos">
              <div class="p-2 bg-warning text-white d-flex align-items-center small">
                <i class="fa fa-filter ml-1 mr-2"></i>
                <div>Filtro de pesquisa ativado</div>
                <div class="ml-auto text-nowrap"><a href="javascript:" @click="clearPesquisa()" class="text-white"><u>Limpar</u></a></div>
              </div>
              <div class="row no-gutters">
                <div class="col-sm-6 col-lg-12" v-for="(p, i) in pedidos" :key="i">
                  <kanban-item :p="p" :nome="multiple" @abrirPedido="abrirPedido"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 px-1" v-if="pesquisa.status === '6'">
        <div class="kanban-coluna" :class="{'aberto': menu === 6}">
          <div class="kanban-col-header bg-secondary">
            <div>AGENDADOS</div>
          </div>
          <div class="kanban-col-body">
            <loading style="padding-top: 48px" v-if="loadPedidos"/>
            <div v-show="!loadPedidos">
              <div class="mx-2 mt-2 p-2 border rounded-lg d-flex align-items-center" style="line-height: 1rem">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calendar-time" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"/><circle cx="18" cy="18" r="4"/><path d="M15 3v4M7 3v4m-4 4h16m-1 5.496V18l1 1"/></svg>
                </div>
                <b class="mx-2 small">Os pedidos permanecem nesta fila e retornam no dia agendado.</b>
                <div class="ml-auto small"><a href="javascript:" @click="clearPesquisa()" class="text-secondary"><u>Voltar</u></a></div>
              </div>
              <div class="row no-gutters">
                <div class="col-sm-6 col-lg-12" v-for="(p, i) in agendados" :key="i">
                  <div class="row no-gutters align-items-center">
                    <div class="col-1 text-center pl-2" v-if="emLote === 2">
                      <input :checked="!!selecionados.find(pedido => pedido.id_pedido === p.id_pedido)" type="checkbox" @change="abrirPedido(p)">
                    </div>
                    <div class="col">
                      <kanban-item :p="p" :load="loadAcao" :nome="multiple" :emLote="emLote" :entregadores="user.entregadores" @abrirPedido="abrirPedido" @escolherEntregador="escolherEntregador"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fixed-bottom bg-white py-2 border-top d-md-none" style="z-index: 0">
      <div class="row no-gutters px-2">
        <div class="col-6 px-1" v-if="modal">
          <button class="btn btn-dark p-3" @click="$emit('fecharModal')" title="Fechar" v-if="modal">
            <i class="fa fa-chevron-left mr-1"></i> Voltar
          </button>
        </div>
        <div class="col-6 px-1" v-else>
          <button class="btn btn-dark btn-block py-3" title="Imprimir Resumo dos Pedidos" @click="visualizarResumo()" :disabled="paLoad">
            <i class="fa fa-chart-line mr-1"></i> Resumo
          </button>
        </div>
        <div class="col-6 px-1">
          <button class="btn btn-secondary btn-block py-3" @click="$refs.manual.openPedidoManual()">
            <i class="fa fa-plus mr-1"></i> Pedido
          </button>
        </div>
      </div>
    </div>

    <div class="modal-pdv modal-kanban" :class="{'show': aberto}">
      <div class="modal-pdv-content p-0" :class="{'is-modal': modal}" v-show="aberto">
        <div class="pd">
          <div class="pd-header border-bottom shadow-sm">
            <button class="btn btn-outline-dark" @click="fecharModalPedido()" style="width: 42px; font-size: 18px" title="Fechar">
              <i class="fa fa-chevron-left"></i>
            </button>
            <div class="ml-auto mr-1" v-if="!loadDetalhes && selecionado && !selecionado.id_comanda && user.habilitar_comanda === '1'">
              <a href="javascript:" class="btn btn-primary" @click="importar()" title="Importar para o PDV"><i class="fa fa-cloud-download-alt"></i></a>
            </div>
            <div class="d-md-none" v-if="!loadDetalhes && !loadAcao">
              <a href="javascript:" class="btn btn-primary" @click="prepararImpressao()"><i class="fa fa-print"></i></a>
            </div>
            <div v-if="!loadDetalhes && selecionado && selecionado.status < 4">
              <button type="button" class="btn btn-secondary" title="Editar Pedido" @click="editarPedido(selecionado)">
                <i class="fa fa-edit"></i>
              </button>
            </div>
          </div>
          <div class="pd-content rounded">
            <loading style="padding-top: 48px" v-if="!selecionado || loadDetalhes || loadAcao"/>
            <div v-else-if="selecionado">
              <cupom-delivery :selecionado="selecionado" :preview="aberto"
                @modalIntegracao="openModalIntegracao"
                @toggleCliente="toggleCliente"
                @escolherEntregador="escolherEntregador"
                @openMapa="openMapa(true)"
                @openModalPagamento="openModalPagamento"
              />
            </div>
          </div>
          <div class="pd-bottom border-top bg-white" v-if="selecionado">
            <div class="d-flex justify-content-between">
              <div class="btn-imprimir mr-2">
                <button class="btn btn-outline-dark btn-block" :disabled="paLoad" @click="prepararImpressao()" :class="{'visibility':!selecionado.status}">
                  Imprimir
                </button>
              </div>
              <div class="btn-cancelar mr-2" v-show="['1','2','3'].includes(selecionado.status)">
                <button :disabled="loadAcao || paLoad" class="btn btn-secondary btn-block" @click="openModalCancelamento">{{selecionado.status === '1' ? 'Recusar' : 'Cancelar'}}</button>
              </div>
              <div class="btn-aceitar ml-auto" v-if="selecionado.status === '1'">
                <button class="btn btn-success btn-block" @click="acaoPedido(selecionado,2)" :disabled="loadAcao || paLoad">Aceitar</button>
              </div>
              <div class="btn-aceitar ml-auto" v-if="selecionado.status === '2'">
                <button :disabled="loadAcao || paLoad" class="btn btn-info btn-block" @click="escolherEntregador(selecionado, true)">Despachar</button>
              </div>
              <div class="btn-aceitar ml-auto" v-if="selecionado.status === '3'">
                <button :disabled="loadAcao || paLoad" class="btn btn-dark btn-block" @click="finalizarPedido(selecionado)">Finalizar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal width="tiny" :opened="modalCancelamento">
      <div v-if="loadModal" class="py-5">
        <loading text="Buscando cancelamentos disponíveis"/>
      </div>
      <div v-else>
        <div class="mb-2">
          <label for="motivoCancelamento" class="small mb-0"><b>Motivo do cancelamento*</b></label>
          <select id="motivoCancelamento" class="form-control" style="max-width: 300px" v-model="cancelamento.tipo_cancelamento" @change="changeCancelamento">
            <option :value="null">Selecione um motivo</option>
            <option v-for="r in motivos" :key="r.tipo_cancelamento" :value="r.tipo_cancelamento">{{r.obs_cancelamento}}</option>
          </select>
        </div>
        <div>
          <label class="small mb-0"><b>Observação adicional<span v-if="cancelamento.requer_observacao">*</span></b></label>
          <textarea id="textCancelamento" v-model="cancelamento.obs_cancelamento" :disabled="!cancelamento.requer_observacao" class="form-control mb-4" placeholder="Informe o motivo para recusar este pedido" rows="5" style="resize: none"></textarea>
        </div>
      </div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-6 pr-1">
            <button class="btn btn-dark btn-block" @click="modalCancelamento = false">Voltar</button>
          </div>
          <div class="col-6 pl-1">
            <button :disabled="!podeConfirmarCancelamento" class="btn btn-success btn-block" @click="cancelarPedido()"><b>Confirmar</b></button>
          </div>
        </div>
      </div>
    </modal>

    <modal :opened="modalPagamento">
      <div v-if="modalPagamento === 1">
        <h6 class="pointer text-center border-bottom pb-3 mb-0">Histórico de Pagamentos</h6>
        <div class="table-responsive" v-if="pagamentos && pagamentos.length">
          <table class="table border rounded-sm small my-2">
            <tr class="bg-light">
              <th>Pagamento</th>
              <th>Status</th>
              <th>&nbsp;</th>
            </tr>
            <tr v-for="p in pagamentos">
              <td class="text-nowrap">{{p.created_at}}</td>
              <td>
                LeCard: {{p.status_lecard | status}} <br>
                Getway: {{p.status}}
              </td>
              <td>
                <a v-if="p.plataforma == 1" :href="`https://www.mercadopago.com.br/activities/1?q=${p.codigo_externo}`" target="_blank">Visualizar</a>
                <a v-else-if="p.plataforma == 5" :href="`https://dash.pagar.me/`" target="_blank">Visualizar</a>
              </td>
            </tr>
          </table>
        </div>
        <div class="my-5 text-center" v-else>
          <p class="mb-0">{{loadModal ? 'Carregando dados..' : 'Não foi encontrado nenhum pagamento'}}</p>
        </div>
      </div>
      <div v-if="modalPagamento === 2" style="max-height: 300px; overflow: auto">
        <div class="border-bottom p-1 pb-3 d-flex align-items-center justify-content-between">
          <h6 class="pointer text-center mb-0">Logs da Integração</h6>
          <a :href="`https://gestordepedidos.ifood.com.br/#/home/orders/now/${selecionado.ifood_id}`" class="btn btn-primary btn-sm" target="_blank" v-if="selecionado.ifood_id">
            Abrir pedido
          </a>
          <a href="https://www.uairango.com/estabelecimento/0/pedidos" class="btn btn-primary btn-sm" target="_blank" v-if="selecionado.uairango_id">
            Abrir pedido
          </a>
        </div>
        <div class="table-responsive" v-if="logsIntegrador && logsIntegrador.length">
          <table class="table border rounded-sm small my-2">
            <tr class="bg-light">
              <th>Código</th>
              <th>Log</th>
            </tr>
            <tr v-for="l in logsIntegrador">
              <td class="align-middle" style="width: 66px">{{ l.code }}</td>
              <td>
                <div>{{ l.created_at }}</div>
                <div>Status: {{l.status === '1' ? 'Processado' : 'Pendente' }}</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="my-5 text-center" v-else>
          <p class="mb-0">{{loadModal ? 'Carregando dados..' : 'Não foi encontrado nenhum log deste pedido'}}</p>
        </div>
      </div>
      <div class="border-top pt-3 text-center">
        <button class="btn btn-dark rounded-sm" @click="modalPagamento = false">Voltar</button>
      </div>
    </modal>

    <modal :opened="modalMapa" width="full">
      <div class="bg-light p-2">
        <div class="text-right">
          <a class="btn btn-info px-3 mr-2" href="https://lecard.tawk.help/article/mapa-de-entrega" target="_blank"><i class="fa fa-question-circle mr-1"></i> Ajuda</a>
          <button class="btn btn-outline-primary px-3 mr-1" style="width: 52px" title="Atualizar pedidos" @click="sincronizarMapaAberto(false)"><i class="fa fa-sync-alt"></i></button>
          <button class="btn btn-outline-dark px-3" @click="closeMapa()" title="Fechar" style="width: 52px"><i class="fa fa-times"></i></button>
        </div>
      </div>
      <map-gestor ref="mapa" :token="pesquisa.key" :modalMapa="modalMapa" @fechar="closeMapa()" @despachar="despacharMapa" @escolherEntregador="escolherEntregador"/>
    </modal>

    <modal :opened="modalImpressao" v-if="!usaNovaImpressao">
      <div class="container-fluid">
        <h6 class="font-weight-bold text-center border-bottom pb-3 mb-0">Qual local você quer imprimir?</h6>
        <div v-for="c in impressoras" class="my-3">
          <label class="mb-0 d-block mb-3">
            <input type="checkbox" class="mr-1" :value="c.device" v-model="cozinhas">
            {{ c.nome_cozinha }}
          </label>
        </div>
        <div class="border-top pt-3 text-center d-flex justify-content-between">
          <button class="btn btn-light border p-3 " @click="modalImpressao = false"><i class="fa fa-angle-left"></i> Voltar</button>
          <button :disabled="!cozinhas.length" class="btn btn-success p-3" @click="imprimir(selecionado, 1, cozinhas)">
            Imprimir
          </button>
        </div>
      </div>
    </modal>

    <modal-reimpressao-delivery
      v-if="usaNovaImpressao"
      :loading="loadRegrasImpressao"
      :opened="modalImpressao"
      :regras="regrasImpressao"
      @close="fecharModalImpressao()"
      @confirm="confirmarReimpressao($event)"
    />

    <modal :opened="modalResumo" no-pad="true">
      <div class="height-100 py-3">
        <resumo-pedidos :empresas="empresas" v-if="modalResumo" :pesquisa="pesquisa"/>
      </div>
      <div class="border-top p-2 text-center d-flex justify-content-between">
        <button class="btn btn-dark border p-3" @click="modalResumo = false"><i class="fa fa-angle-left mr-1"></i> Voltar</button>
        <div>
          <button class="btn btn-primary px-4 py-3" @click="imprimirResumo()">Imprimir <i class="fa fa-print ml-1"></i></button>
        </div>
      </div>
    </modal>

    <modal-entregador :multiplos-pedidos="!pedidoEntregador && selecionados.length > 1" :opened="modalEntregador" :selecionado="pedidoEntregador ? pedidoEntregador.id_entregador : null"
                      @fechar="fecharModalEntregador" @logistica="abrirLogistica" @selecionar="salvarEntregador"/>
    <modal-logistica :despachar="despacharComEntregador" :opened="modalLogistica" :pedidos="pedidoEntregador ? [pedidoEntregador] : selecionados"
                     :plataforma-selecionada="plataformaLogistica"
                     @atualizar="atualizarSolicitacaoEntregador" @fechar="fecharModalEntregador"/>

    <pedido-manual ref="manual" @fechar="atualizarPedidoManual"/>
    <finalizar-simples ref="finSimples" :isPdv="modal" @atualizar="atualizarFinalizados" @reprocessar="concluirEmMassa()"/>

    <div class="d-none" v-if="paSelecionado">
      <cupom-delivery id="paCupom" :selecionado="paSelecionado"/>
    </div>
  </div>
</template>

<script>
import MsgHome from "./MsgHome";
import TopBar from '../commons/TopBar.vue'
import Modal from './ModalGestor'
import MapGestor from "./MapGestor";
import Loading from "./loading";
import PesquisarKanban from "@/components/gestor/PesquisarKanban";
import ResumoPedidos from "@/components/gestor/ResumoPedidos";
import PedidoManual from "@/components/gestor/PedidoManual";
import KanbanItem from "@/components/gestor/KanbanItem";
import CupomDelivery from "@/components/gestor/CupomDelivery";
import FinalizarSimples from "@/views/comanda/pdv/FinalizarSimples";
import ModalLogistica from "@/components/gestor/ModalLogistica";
import ModalEntregador from "@/components/gestor/ModalEntregador";
import ModalReimpressaoDelivery from "@/components/gestor/ModalReimpressaoDelivery";

export default {
  name: 'KanbanPedidos',
  props: ['modal'],
  components: {
    ModalReimpressaoDelivery,
    ModalEntregador,
    ModalLogistica,
    FinalizarSimples,
    CupomDelivery,
    KanbanItem,
    PedidoManual,
    ResumoPedidos,
    PesquisarKanban,
    Loading,
    MapGestor,
    MsgHome,
    Modal,
    TopBar
  },

  data() {
    return {
      loadPedidos: false,
      loadAguardando: false,
      socketTimeout: false,
      loadAcao: false,
      loadModal: false,
      loadDetalhes: false,
      loadRegrasImpressao: false,
      token: localStorage.getItem('key'),
      agora: this.$dayjs(),
      intervalAgr: null,

      pedidos: [],
      pedidosCache: [],
      aguardando: [],
      filaPrints: [],

      selecionado: null,
      selecionados: [],
      emLote: null,
      modalEntregador: false,
      modalLogistica: false,
      plataformaLogistica: null,
      pedidoEntregador: null,
      despacharComEntregador: false,
      reprocessar: null,
      modalOutros: false,
      selFinalizado: null,

      modalCancelamento: false,
      modalPagamento: false,
      modalImpressao: false,
      motivos: [],

      modalMapa: false,
      pesquisaMapa: {
        id_pedido: '',
        status: '2'
      },

      pesquisa: {
        id_empresa: '',
        tipo_pedido: '',
        ativada: false,
        page: 0,
        filtro: '1',
        status: '1',
        origin: '',
        key: '',
        data: ''
      },

      cancelamento: {
        tipo_cancelamento: null,
        obs_cancelamento: '',
        requer_observacao: false
      },

      socket: true,
      multiple: false,

      modalResumo: false,
      cozinhas: [],
      pagamentos: [],
      impressoras: [],
      regrasImpressao: [],
      aberto: false,

      paLoad: false,
      paSelecionado: null,
      paTimeOut: null,

      menu: 1,
      lecardTimeOut: null,
      processIfood: false,
      logsIntegrador: [],
      pagination: 100,
      isRead: false,
      ifood: false,
      showPiloto: false
    }
  },

  methods: {
    filtrar(pesquisa) {
      this.selecionados = [];
      this.pesquisa = { ...this.pesquisa, ...pesquisa };
      this.menu = parseInt(this.pesquisa.status);

      if (this.pesquisa.status !== '1' && this.pesquisa.status !== '6') {
        if (this.loadPedidos) return;

        this.loadPedidos = true;
        this.pedidos = [];
        this.requestPedidos(this.pesquisa);
      }
    },

    filtrarComputed(status) {
      let lista = this.pedidosCache.filter(p => p.status === status);
      const data = this.pesquisa.data?.trim().toLowerCase() || null;

      if (data) {
        if (this.pesquisa.filtro === '1') {
          lista = isNaN(data)
              ? lista.filter(p => p._nome_cliente.includes(data))
              : lista.filter(p => p.id_contador.includes(data));
        } else {
          lista = lista.filter(p => p._endereco.includes(data));
        }
      }

      if (this.pesquisa.origin) {
        lista = lista.filter(p => p.origin === this.pesquisa.origin);
      }

      if (this.pesquisa.tipo_pedido) {
        lista = lista.filter(p => p.tipo_pedido === this.pesquisa.tipo_pedido);
      }

      if (this.pesquisa.id_empresa) {
        lista = lista.filter(p => p.id_empresa === this.pesquisa.id_empresa);
      }

      // ordena os pedidos mais antigos primeiro
      return lista.sort((a, b) => {
        return parseInt(a.id_pedido) - parseInt(b.id_pedido);
      });
    },

    clearPesquisa() {
      this.menu = 1;
      this.pedidos = [];
      this.emLote = null;
      this.selecionados = [];
      this.pesquisa.id_empresa = '';
      this.pesquisa.filtro = '1';
      this.pesquisa.status = '1';
      this.pesquisa.origin = '';
      this.pesquisa.tipo_pedido = '';
      this.pesquisa.page = 0;
      this.pesquisa.data = '';
      this.pesquisa.ativada = false;
      this.$emit('clearPesquisa');
    },

    paginarPedidos(count) {
      if (this.loadPedidos) {
        return;
      }

      const page = this.pesquisa.page + count;

      if (page >= 0 && !this.paLoad) {
        this.loadPedidos = true;
        this.pedidos = [];
        this.pesquisa.page = page;
        this.pesquisa.ativada = true;
        this.requestPedidos(this.pesquisa);
      }
    },

    abrirPedido(p) {
      if (p.id_pedido) {
        if (this.emLote) {
          const encontrou = !!this.selecionados.find(s => s.id_pedido === p.id_pedido);

          if (!encontrou && this.selecionados.length >= 50) {
            this.$swal('O máximo permitido de pedidos selecionados é 50');
            return;
          }

          this.selecionados = encontrou ? this.selecionados.filter(el => el.id_pedido !== p.id_pedido) :
              [...this.selecionados, { id_pedido: p.id_pedido, tipo_pedido: p.tipo_pedido, id_empresa: p.id_empresa }];
          return;
        }

        this.aberto = true;

        this.buscarPedidoId(p, (data) => {
          this.selecionado = data || {};

          if (!data) {
            this.$swal(`Erro ao buscar os dados deste pedido. Por favor verifique sua conexão com a internet.`);
            this.aberto = false;
          }

        }, true);

        if (p.status === '1') {
          this.pauseNotification();
        }
      }
    },

    finalizarPedido(p) {
      if (!p.id_comanda || p.origin === '4') {
        this.acaoPedido(p, 4);
        return;
      }

      this.selFinalizado = p;
      this.$refs.finSimples.finalizarPedidoVenda(p.id_comanda, p.id_pedido);
      this.fecharModalPedido();
    },

    atualizarFinalizados(finalizarPedido) {
      if (finalizarPedido) {
        this.acaoPedido(this.selFinalizado, 4);

      } else {
        this.statusListaPedidos(4, this.selFinalizado.id_pedido);
        this.notificarSocket(this.selFinalizado.token, this.selFinalizado);
      }
    },

    selPedidosDespachar() {
      this.clearPesquisa();

      if (this.preparando.length) {
        this.menu = 2;
        this.emLote = 2;

      } else {
        this.$swal("Não há pedidos na fila 'Preparando' aguardando para serem despachados");
      }
    },

    selPedidos(fila) {
      let qtd = 0;
      let lista = fila === 2 ? this.preparando : this.despachados;

      if (this.selecionados.length === lista.length) {
        this.selecionados = [];
        return;
      }

      this.selecionados = [];
      lista.forEach(pedido => {
        if (qtd < 50) {
          this.selecionados.push({ id_pedido: pedido.id_pedido, tipo_pedido: pedido.tipo_pedido, id_empresa: pedido.id_empresa });
        }

        qtd++;
      });
    },

    buscarPedidosFila(status, sync, callback) {
      if (this.loadPedidos) {
        return;
      }

      this.loadPedidos = !status;
      const params = { status, isonline: (!!sync && !this.master), key: this.token }
      this.requestPedidos(params, callback);
    },

    requestPedidos(params, callback) {
      if (params.status === 1 && this.paLoad) {
        return;
      }

      this.$http.get('v2/pedidos/fila', { params })
        .then(response => {
          this.finalizarLoad();
          const pedidos = response.data || [];

          if (params.status && parseInt(params.status) > 3) {
            this.pedidos = pedidos;

          } else if (params.status === 1) {
            this.aguardando = pedidos;

          } else {
            this.aguardando = pedidos.filter(p => p.status === '1');

            // Atualiza a lista de pedidos
            this.pedidosCache = pedidos.filter(p => p.status !== '1').map(p => this.normalizarPedido(p));

            if (callback) callback();
          }

          if (this.pilotoAutomatico) {
            this.setFilaPa(); // aceitar o pedido automaticamente

          } else {
            this.tocarNotificacao();
          }

        }, res => {
          console.log(res);
          this.finalizarLoad();
          const data = res.data || {};

          if (res.status === 401) {
            this.logout(true);

          } else if (!navigator.onLine) {
            this.$swal("Não conseguimos sincronizar os pedidos. Por favor verifique se seu computador tem uma conexão estável.");

          } else {
            this.$swal(data.msg || "Não foi possível sincronizar os pedidos.");
          }
        });
    },

    finalizarLoad() {
      this.loadPedidos = false;
      this.loadAguardando = false;
      this.$store.state.load = false;
    },

    setFilaPa() {
      if (!this.paLoad && this.aguardando.length) {
        this.paLoad = true;
        this.playNotification(2);

        if (this.usaNovaImpressao) {
          this.loopFilaPa();
          return;
        }

        if (this.printServer) {
          const dataPedidos = this.aguardando.map(pedido => {
            return {
              nome_documento: `Pedido: ${pedido.id_contador}`,
              id_pedido: pedido.id_pedido,
              status: 2,
              tipo: 2
            }
          });

          // Log do pedido para ser registrado no comanda_impressao
          this.$http.post('pdv/impressao/' + this.token, { dataPedidos })
            .then(res => {
              if (res.data?.success) {
                this.loopFilaPa();

              } else {
                this.pararFilaPa();
                this.showErrorPa(res.data?.msg || 'Piloto automático. Erro ao registrar pedidos');
              }

            }, res => {
              console.log(res);
              this.pararFilaPa();
              this.showErrorPa(res.data?.msg || 'Piloto automático. Erro ao registrar pedidos');
            });

        } else {
          this.loopFilaPa();
        }
      }
    },

    loopFilaPa() {
      if (!this.pilotoAutomatico) {
        console.log('pararFila')
        this.pararFilaPa();
        return;
      }

      this.paLoad = true;
      const qtdAguardando = this.aguardando.length;

      if (qtdAguardando) {
        const pedido = this.aguardando[qtdAguardando - 1];
        pedido.receiver = '2'; // marca que foi aceito pelo piloto

        this.acaoPedido(pedido, 2, (data) => {
          // Foi aceito com sucesso
          if (this.usaNovaImpressao && data && data.success) {
            this.acompanharImpressaoPedido(data.id_impressao, pedido.id_pedido, data.ids_impressao);
            this.aguardando = this.aguardando.filter(p => p.id_pedido !== pedido.id_pedido);
            document.dispatchEvent(new CustomEvent('logInfo', { detail: `Piloto Automatico. Pedido aceito: ${pedido.id_pedido}` }));
            this.paTimeOut = setTimeout(() => {
              this.loopFilaPa();
            }, 4000);

          } else if (data && data.pedido?.id_pedido) {
            this.aguardando = this.aguardando.filter(p => p.id_pedido !== pedido.id_pedido);
            this.imprimirFilaPa(data.pedido);

          } else {
            this.pararFilaPa();
            this.playNotification();
            this.showErrorPa(`Erro ao aceitar o pedido: ${pedido.id_contador || pedido.id_pedido}. Por favor verifique se ele foi impresso.`);

            // Tenta novamente após 12 segundos
            setTimeout(() => {
              this.pauseNotification();
              this.buscarPedidosFila(1);
            }, 12000);
          }
        });

      } else {
        setTimeout(() => {
          // Verifica se os pedidos do loop foram impressos
          if (!this.usaNovaImpressao && this.printLocal) {
            this.validarImpressao(true);
          }

          // Retorna o loop
          this.pararFilaPa();
          this.buscarPedidosFila();
        }, 4000);
      }
    },

    imprimirFilaPa(pedido) {
      this.paSelecionado = pedido;
      this.$nextTick(() => {
        document.dispatchEvent(new CustomEvent('logInfo', { detail: `Piloto Automatico. Pedido aceito: ${pedido.id_pedido}` }));
        this.imprimir(this.paSelecionado, this.impressora.nCopias || 1, null, true);

        this.paTimeOut = setTimeout(() => {
          this.loopFilaPa();
        }, 4000);
      });
    },

    showErrorPa(texto, titulo) {
      this.$store.commit('addOcorrencia', {
        titulo: titulo || 'Piloto Automático',
        tipo: '3',
        texto_informe: texto
      });

      document.dispatchEvent(new CustomEvent('logError', { detail: `Piloto Automatico. ${texto}` }));
    },

    pararFilaPa() {
      this.paLoad = false;

      if (this.paTimeOut) {
        clearTimeout(this.paTimeOut);
        this.paTimeOut = null;
      }
    },

    marcarPedidosImpressos() {
      if (!this.usaNovaImpressao || !this.impressoesKanbanConfirmadas.length) return;

      this.impressoesKanbanConfirmadas.forEach(id => {
        const pedido = this.encontrarPedido(id);
        const selecionado = this.selecionado && String(this.selecionado.id_pedido) === String(id)
          ? this.selecionado : null;

        if (!pedido) return;

        const dataImpressao = pedido.impresso || (selecionado && selecionado.impresso) || this.$dayjs();
        if (!pedido.impresso) this.$set(pedido, 'impresso', dataImpressao);
        if (selecionado && !selecionado.impresso) this.$set(selecionado, 'impresso', dataImpressao);

        this.$store.commit('finalizarImpressaoKanban', id);
      });
    },

    validarImpressao(piloto) {
      // Filtra os que não estão nos impressos
      const idsImpressos = this.$store.state.orderPrints;
      const naoImpressos = this.filaPrints.filter(f => !idsImpressos.includes(f.id_pedido));

      if (naoImpressos.length) {
        const ids = naoImpressos.map(p => p.id_contador || p.id_pedido).join(', ');
        const message = (naoImpressos.length > 1) ? `Os pedidos [${ids}] não foram impressos` : `O pedido: ${ids} não foi impresso`;
        this.showErrorPa(`⚠️ ${message}. Verifique a impressora.`, !piloto ? 'Erro ao imprimir' : null);
      }

      // marcar os impressos:
      idsImpressos.forEach(id => {
        const pImpresso = this.encontrarPedido(id);

        if (pImpresso) {
          pImpresso.impresso = this.$dayjs();
          document.dispatchEvent(new CustomEvent('logInfo', {
            detail: `Pedido ${id} marcado como impresso às: ${pImpresso.impresso.format('HH:mm:ss')}`
          }));

          this.$store.commit('removerOrderPrint', id);
        }
      });

      this.filaPrints = [];
    },

    pausarNotificacao() {
      this.$store.commit('setBell', false);
      this.pauseNotification();
    },

    tocarNotificacao() {
      const aguardando = this.aguardando.length;

      if (aguardando > 0) {
        this.$store.commit('setBell', aguardando);
        this.playNotification();

      } else {
        this.pausarNotificacao();
      }
    },

    buscarPedidoId(dados, callback, load) {
      if (!dados) {
        callback(null);
        return;
      }

      this.cozinhas = [];
      this.loadDetalhes = (load === true);

      this.$http.get(`delivery/pedidos/${this.token}/${dados.id_pedido}`)
        .then(response => {
          this.loadDetalhes = false;
          const data = response.data || {};

          if (data.id_pedido) {
            callback(data);

          } else {
            this.$swal(`Pedido ${dados.id_pedido} não encontrado!`)
            callback(null);
          }

        }, res => {
          console.log(res);
          this.loadDetalhes = false;
          callback(null);

          if (res.status === 401) {
            this.logout(true);
          }
        });
    },

    statusListaPedidos(status, id_pedido, id_comanda) {
      const pedido = this.encontrarPedido(id_pedido);

      if (!pedido || parseInt(pedido.status) == status) return;

      // Atualiza o status e comanda
      pedido.status = status.toString();

      if (id_comanda && !pedido.id_comanda) {
        pedido.id_comanda = id_comanda;
      }

      // Remove de aguardando
      if (status === 2 || status === 5) {
        this.aguardando = this.aguardando.filter(p => p.id_pedido !== id_pedido);
      }

      // Se ainda não está no pedidosCache, adiciona
      if (!this.pedidosCache.find(p => p.id_pedido === id_pedido)) {
        const pedidoNormalizado = this.normalizarPedido(pedido);
        this.pedidosCache.push(pedidoNormalizado);

      } else if (status === 3) {
        pedido._atrasado = false;
      }
    },

    fecharModalPedido() {
      this.aberto = false;
      this.selecionado = {
        tags: [],
        produtos: [],
        troco: 0,
        total: 0
      };
    },

    solicitarImpressaoPedido(pedido, options = {}) {
      if (!pedido || !pedido.id_pedido) {
        return;
      }

      const { regras = null, destino = null, qtd_copias = 1 } = options;
      const payload = { id_pedido: pedido.id_pedido };

      if (destino) {
        payload.destino = destino;
        payload.qtd_copias = qtd_copias;
      } else if (regras && regras.length) {
        payload.regras = regras;
        payload.qtd_copias = qtd_copias;
      }

      this.$store.state.load = "Enviando, aguarde..";

      this.$http.post('v2/impressao/delivery-pedido', payload).then((res) => {
        this.$store.state.load = false;
        const data = res.data || {};

        if (data.success) {
          this.acompanharImpressaoPedido(data.id_impressao, pedido.id_pedido, data.ids_impressao);
          this.$swal('Impressão enviada para o servidor de impressão!');
          return;
        }

        const erro = (res.data || {}).erro || 'Não foi possível enviar o pedido para a fila de impressão.';

        this.$store.commit('addOcorrencia', {
          titulo: 'Impressão de Pedido',
          tipo: '3',
          texto_informe: erro
        });

      }, (res) => {
        this.$store.state.load = false;
        const erro = (res.data || {}).erro || 'Não foi possível enviar o pedido para a fila de impressão.';

        this.$store.commit('addOcorrencia', {
          titulo: 'Impressão de Pedido',
          tipo: '3',
          texto_informe: erro
        });
      });
    },

    acompanharImpressaoPedido(id_impressao, id_pedido, ids_impressao) {
      if (this.usaNovaImpressao) {
        if (id_impressao) this.$store.commit('aguardarImpressaoKanban', id_pedido);

        if (!this.printServer) {
          const ids = Array.isArray(ids_impressao) && ids_impressao.length ? ids_impressao : [id_impressao];
          this.$store.commit('acompanharImpressaoRemota', ids);
        }

        return;
      }

      if (!id_impressao || this.printServer) {
        return;
      }

      this.$helpers.awaitImpressao(this, id_impressao, 10000, 1);
    },

    carregarRegrasImpressao(pedido, callback) {
      this.loadRegrasImpressao = true;

      this.$http.get(`v2/impressao/delivery-pedido/${pedido.id_pedido}/regras`)
        .then((res) => {
          this.loadRegrasImpressao = false;
          callback(res.data || []);
        }, (res) => {
          this.loadRegrasImpressao = false;
          callback([], (res.data || {}).erro || 'Não foi possível obter as regras de impressão.');
        });
    },

    confirmarReimpressao(options) {
      this.fecharModalImpressao();
      this.solicitarImpressaoPedido(this.selecionado, options);
    },

    fecharModalImpressao() {
      this.modalImpressao = false;
      this.regrasImpressao = [];
    },

    acaoPedido(pedido, status, callback, drag) {
      if (pedido.status >= status) {
        if (callback) callback(null);
        return null;
      }

      this.loadAcao = pedido.id_pedido;

      let dados = {
        status,
        id_pedido: pedido.id_pedido,
        origin: pedido.origin ? pedido.origin.toString() : '',
        receiver: pedido.receiver || '1',
        id_empresa: pedido.id_empresa,
        empresa: pedido.token
      };

      if (this.usaNovaImpressao && status === 2 && (Number(this.configImpressao.print_automatico || 0) === 1 || dados.receiver === '2')) {
        dados.solicitar_impressao = true;
      }

      if (status === 2) {
        this.pausarNotificacao();

      } else if (status === 5) {
        dados.tipo_cancelamento = this.cancelamento.tipo_cancelamento;
        dados.obs_cancelamento = this.cancelamento.obs_cancelamento;
        this.modalCancelamento = false;
      }

      if (drag) {
        this.statusListaPedidos(status, dados.id_pedido);
      }

      const cancelamentoPendente = status === 5 && ['6', '11'].includes(dados.origin);

      this.$http.post('delivery/pedidos/' + this.token, dados)
        .then(res => {
          this.$store.state.load = false;
          this.loadAcao = false;
          const data = res.data;

          if (data.success) {
            this.$helpers.registrarFalhaImpressaoPedido(this, pedido, data, dados.solicitar_impressao === true);

            if (this.aberto && this.selecionado && this.selecionado.id_pedido === dados.id_pedido) {
              if (!cancelamentoPendente) {
                this.selecionado.status = status.toString();
              }

              if (data.id_comanda && !this.selecionado.id_comanda) {
                this.selecionado.id_comanda = data.id_comanda;
              }

              if (dados.obs_cancelamento) {
                this.selecionado.obs_cancelamento = dados.obs_cancelamento;
              }
            }

            const imprimir = (status === 2 && this.impressora.automatico === '1');

            if (callback) {
              callback(data);

            } else if (this.usaNovaImpressao && status === 2) {
              this.acompanharImpressaoPedido(data.id_impressao, pedido.id_pedido, data.ids_impressao);

            } else if (imprimir) {
              if (data.pedido?.id_pedido) {
                this.selecionado = data.pedido;
                this.$nextTick(() => {
                  this.imprimir(this.selecionado, this.impressora.nCopias || 1);
                });

              } else {
                this.$store.commit('addOcorrencia', {
                  titulo: 'Impressão de Pedido',
                  tipo: '3',
                  texto_informe: `Erro ao imprimir o pedido: ${pedido.id_contador || pedido.id_pedido}. Não encontrado os dados do pedido.`
                });
              }
            }

            if (cancelamentoPendente) {
              this.$swal("A solicitação de cancelamento foi enviada, por favor aguarde no status do pedido.");

            } else {
              this.notificarSocket(pedido.token, dados);

              if (status === 2) {
                pedido.id_comanda = data.id_comanda || null;
                this.$socket.emit('delivery_kds', { token: pedido.token, content: { id_pedido: dados.id_pedido, status: '1' } });

              } else if (status === 5) {
                this.$swal("Cancelamento realizado com sucesso!");
                this.$socket.emit('delivery_kds', { token: pedido.token, content: { id_pedido: dados.id_pedido, status: '4' } });
              }
            }

            if (!drag && !cancelamentoPendente) {
              this.statusListaPedidos(status, dados.id_pedido);
            }

            if (status === 2) {
              this.sincronizarMapaAberto();
            }

            if (this.pesquisa.ativada && this.pesquisa.filtro === '1') {
              this.$nextTick(() => {
                this.$helpers.focusElement( 'pesquisarPedido');
              })
            }

          } else {
            this.$swal(data.msg || "Por favor, tente novamente");

            if (callback) {
              callback(false);

            } else {
              this.buscarPedidosFila();
            }
          }

        }, res => {
          this.loadAcao = false;
          this.$store.state.load = false;
          const error = (res.data || {}).msg || 'Não foi possível alterar o status deste pedido. Por favor verifique sua conexão com a internet.';
          const errorStatus = (res.data || {}).status || status;

          if (callback) {
            callback(null);
            return;
          }

          if (dados.origin == 7) {
            this.$swal("Pedido UaiRango: " + error);
          }

          this.$swal(error).then(() => {
            if (errorStatus == 2) {
              this.buscarPedidosFila();
            }
          });

          if (res.status === 401) {
            //window.location.reload();
          }
        });
    },

    notificarSocket(token, dados, sincronizar) {
      if (token) {
        this.$socket.emit('notification', {
          token: token,
          play: false,
          id_pedido: dados.id_pedido,
          status: (dados.status || '') + '',
          session: this.$store.state.session,
          obs_cancelamento: dados.obs_cancelamento,
          pedido_manual: sincronizar
        });
      }
    },

    selPedidosFinalizar() {
      this.clearPesquisa();

      if (this.despachados.length) {
        this.menu = 3;
        this.emLote = 3;

      } else {
        this.$swal("Não existem pedidos na fila dos despachados para serem finalizados");
      }
    },

    alterarEmMassa(status, id_entregador) {
      if (!this.selecionados.length) {
        this.$swal("Por favor selecione pelo menos um pedido");
        return;
      }

      if (status) {
        if (status === 3 && !this.preparando.length) {
          this.$swal("Não existem pedidos pendentes na fila de preparo");
          return;

        } else if (status === 4 && !this.despachados.length) {
          this.$swal("Não existem pedidos na fila para serem finalizados");
          return;
        }
      }

      if (status === 3) {
        if (this.selecionados.find(s => s.tipo_pedido === '1')) {
          this.abrirModalEntregador(null, true);

        } else {
          this.concluirEmMassa(status, id_entregador);
        }

      } else {
        this.$swal({
          text: "Deseja finalizar todos os pedidos selecionados?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then(res => {
          if (res) {
            this.concluirEmMassa(status);
          }
        });
      }
    },

    concluirEmMassa(status, id_entregador) {
      if (this.reprocessar) {
        status = this.reprocessar.status;
        id_entregador = this.reprocessar.id_entregador;
        this.reprocessar = null;
      }

      if (!status) {
        return;
      }

      this.loadPedidos = true;

      const dados = { status, pedidos: this.selecionados };

      if (id_entregador) {
        dados.id_entregador = id_entregador;
      }

      this.$http.post(`v2/pedidos/finalizar/${this.token}`, dados)
        .then(response => {
          this.loadPedidos = false;
          this.$store.state.load = false;

          switch (response.data.result) {
            case 'success':
              const erros = (response.data.erros || 0);

              if (erros) {
                this.$swal("Sucesso", `Pedidos não finalizados: ${erros}\nPor favor finalize manualmente cada pedido.`);
              }

              this.fecharModalPedido();
              this.notificarSocket(localStorage.getItem('token'), {}, true);

              this.buscarPedidosFila(null, false, () => {
                if (this.modalMapa) {
                  this.clearPesquisa();

                  this.$swal({
                    text: 'Pedidos despachados com sucesso! Deseja gerar a rota de entrega?',
                    buttons: ['Não', 'Sim']
                  }).then((res) => {
                    if (res) {
                      this.$refs.mapa.gerarRota(true);

                    } else {
                      this.$refs.mapa.pesquisar();
                    }
                  });

                } else {
                  this.clearPesquisa();
                }
              });

              break;

            case 'caixa':
              this.reprocessar = { status, id_entregador };
              this.$refs.finSimples.finalizarPedidoCaixa(response.data.id_empresa);
              break;

            default:
              this.$swal("Atenção!", response.data.message || 'Erro temporário');
              break;
          }

        }, res => {
          console.log(res);
          this.loadPedidos = false;
          this.$store.state.load = false;
          this.$swal(res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    prepararImpressao() {
      if (!this.selecionado.id_pedido) {
        return;
      }

      if (this.usaNovaImpressao) {
        this.modalImpressao = true;
        this.carregarRegrasImpressao(this.selecionado, (regras, error) => {
          if (error) {
            this.$swal(error);
            return;
          }

          this.regrasImpressao = regras;
        });
        return;
      }

      const cozinhas = this.selecionado.cozinhas || [];
      const deviceDefault = this.impressora.device;
      const devicePdv = this.impressora.devicePdv;
      const impressorasBase = [ { nome_cozinha: 'Impressora pedidos (Padrão)', device: deviceDefault }];

      if (deviceDefault !== devicePdv) {
        impressorasBase.push({ nome_cozinha: 'Impressora comprovante', device: devicePdv });
      }

      this.impressoras = [ ...impressorasBase, ...cozinhas ]

      if (!this.impressora.mobilePrint && this.impressoras.length > 1) {
        this.cozinhas = [deviceDefault];
        this.modalImpressao = true;

      } else {
        const res = this.imprimir(this.selecionado, 1);

        if (res && this.printLocal) {
          this.$swal("Pedido enviado para impressão");
        }
      }
    },

    imprimir(pedido, ncopias, cozinhas, piloto) {
      let html = document.getElementById(piloto ? 'paCupom' : 'containerPedido');

      if (!html) {
        if (piloto) {
          this.showErrorPa(`Erro ao imprimir o pedido: ${pedido.id_contador || pedido.id_pedido}. Imprima manualmente este pedido.`);
        }

        return false;
      }

      html = html.cloneNode(true);
      html.querySelectorAll('.d-print-none').forEach(el => el.remove());
      let content = html.innerHTML.replace(/\sdata-v-[a-z0-9\-]+="[^"]*"/gi, '').replace(/<!--[\s\S]*?-->/g, '').trim();

      let dataPrint = [];
      let detail = {
        content,
        copies: ncopias,
        status: 1,
        id_pedido: pedido.id_pedido,
        nome_documento: `Pedido ${pedido.id_contador}`,
        device: this.impressora.device || null,
        impressora: {
          device: this.impressora.device || null,
          largura: this.impressora.largura,
          zoom: this.impressora.zoom
        }
      };

      if (!this.impressora.mobilePrint && (cozinhas || pedido.cozinhas)) {
        this.modalImpressao = false;

        if (!cozinhas && this.impressora.printCashier) {
          dataPrint.push(detail);
        }

        const devices = cozinhas || pedido.cozinhas.map(c => { return c.device });

        for (let i = 0; i < devices.length; i++) {
          dataPrint.push({
            content,
            copies: 1,
            status: 1,
            id_pedido: pedido.id_pedido,
            nome_documento: `Pedido ${pedido.id_contador}`,
            device: devices[i] || null,
            impressora: {
              device: devices[i] || null,
              largura: this.impressora.largura,
              zoom: this.impressora.zoom
            }
          })
        }

      } else {
        dataPrint.push(detail);
      }

      if (this.printLocal) {
        this.filaPrints.push({
          id_pedido: pedido.id_pedido,
          id_contador: pedido.id_contador
        });
      }

      this.$helpers.imprimir(this, pedido.token, dataPrint, this.impressora.mobilePrint);

      if (!piloto && this.printLocal) {
        setTimeout(() => {
          this.validarImpressao();
        }, 6000);
      }

      return true;
    },

    importar() {
      this.loadDetalhes = true;

      this.$http.post('pdv/pedido-lecard/' + this.token, { id_pedido: this.selecionado.id_pedido })
        .then(res => {
          this.loadDetalhes = false;
          const id = res.data && res.data.id_comanda ? res.data.id_comanda : null;

          if (id) {
            this.$swal("Pedido importado com sucesso!");
            this.buscarPedidoId(this.selecionado, (data) => {
              this.selecionado = data;

              if (data) {
                const pedido = this.encontrarPedido(data.id_pedido);

                if (pedido) {
                  pedido.id_comanda = data.id_comanda;
                }

              } else {
                this.$swal(`Erro ao buscar os dados deste pedido.`)
              }

            }, true);

          } else {
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          }

        }, res => {
          this.loadDetalhes = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
        });
    },

    visualizarResumo() {
      this.$helpers.confirmarSenhaAdm(this, () => {
        this.modalResumo = true;
      });
    },

    imprimirResumo() {
      const html = document.getElementById('resumoDiario');

      if (!html) {
        return;
      }

      const cf = this.$store.state.impressora;
      const device = cf.devicePdv || null;
      const dataImpressao = {
        content: html.innerHTML,
        copies: 1,
        isPdv: true,
        status: 1,
        nome_documento: 'Resumo diário',
        device,
        impressora: {
          device,
          zoom: cf.zoom || "9px",
          largura: cf.largura || '100%'
        }
      };

      this.$helpers.imprimirComprovante(this, localStorage.getItem('token'), [dataImpressao], cf.mobilePrint);
    },

    imprimirExterno(url) {
      const y = window.top.outerHeight / 2 + window.top.screenY - ( 1000 / 2);
      const x = window.top.outerWidth / 2 + window.top.screenX - ( 1000 / 2);
      const myWindow = window.open(url, "", `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=600, height=600, top=${y}, left=${x}`);

      if (myWindow) {
        myWindow.focus();
      }
    },

    openModalCancelamento() {
      this.modalCancelamento = true;
      this.cancelamento.tipo_cancelamento = null;
      this.cancelamento.obs_cancelamento = '';
      this.cancelamento.requer_observacao = false;
      this.pausarNotificacao();

      if (this.loadModal) {
        return;
      }

      this.loadModal = true;
      this.$http.get('v2/pedidos/motivos-cancelamento', {
        params: { id_pedido: this.selecionado.id_pedido },
        headers: { authentication: this.token }
      }).then(response => {
        this.loadModal = false;
        this.motivos = response.data || [];

        if (!this.motivos.length) {
          this.modalCancelamento = false;
          this.$swal("Não há motivos de cancelamento disponíveis para este pedido.");
        }
      }, res => {
        this.loadModal = false;
        this.modalCancelamento = false;
        this.$swal(res.data && (res.data.message || res.data.msg) || "Não foi possível buscar os motivos de cancelamento.");
      });
    },

    cancelarPedido() {
      const motivo = this.motivos.find(m => m.tipo_cancelamento === this.cancelamento.tipo_cancelamento);
      if (!this.cancelamento.obs_cancelamento.trim() && motivo && !motivo.requer_observacao) {
        this.cancelamento.obs_cancelamento = motivo.obs_cancelamento;
      }

      this.$helpers.confirmarSenhaAdm(this, () => {
        this.acaoPedido(this.selecionado, 5);
      });
    },

    changeCancelamento() {
      const motivo = this.motivos.find(m => m.tipo_cancelamento === this.cancelamento.tipo_cancelamento);
      this.cancelamento.requer_observacao = motivo ? motivo.requer_observacao : false;
      this.cancelamento.obs_cancelamento = motivo && !motivo.requer_observacao ? motivo.obs_cancelamento : '';

      if (this.cancelamento.requer_observacao) {
        setTimeout(() => {
          document.getElementById("textCancelamento").focus();
        }, 200);
      }
    },

    openModalPagamento() {
      if (this.loadModal) {
        return;
      }

      this.loadModal = true;
      this.pagamentos = [];
      this.modalPagamento = 1;

      this.$http.get(`pagamentos/${this.token}/${this.selecionado.id_pedido}`)
        .then(response => {
          this.loadModal = false;

          if (response.data && response.data.length) {
            this.pagamentos = response.data;
          }

        }, res => {
          console.log(res);
          this.loadModal = false;
          this.$swal(res.data.msg);
        });
    },

    openModalIntegracao() {
      if (this.loadModal) {
        return;
      }

      this.loadModal = true;
      this.logsIntegrador = [];
      this.modalPagamento = 2;
      const order_id = this.selecionado.ifood_id ? this.selecionado.ifood_id : this.selecionado.uairango_id;

      this.$http.get('integrador/logs/' + this.token, { params: { order_id } })
        .then(response => {
          this.loadModal = false;

          if (response.data && response.data.length) {
            this.logsIntegrador = response.data;
          }

        }, res => {
          console.log(res);
          this.loadModal = false;
          this.$swal(res.data.msg);
        });
    },

    openMapa(openCliente) {
      if (openCliente) {
        const cliente = this.selecionado && this.selecionado.cliente ? this.selecionado.cliente : {};

        if (!cliente.lat_endereco || cliente.distance <= 1) {
          this.$swal("A geolocalização está desativada para este cliente!");
          return;
        }
      }

      this.modalMapa = true;
      this.$refs.mapa.openMapa(openCliente);
    },

    closeMapa() {
      this.clearPesquisa();
      this.$refs.mapa.closeMapa();
      this.modalMapa = false;
      this.buscarPedidosFila(null, true);
    },

    sincronizarMapaAberto(silencioso = true) {
      if (!this.modalMapa || !this.$refs.mapa) {
        return false;
      }

      this.$refs.mapa.sincronizarPedidos(silencioso);
      return true;
    },

    despacharMapa(pedidos) {
      this.emLote = 2;
      this.selecionados = [];

      pedidos.forEach(pedido => {
        this.selecionados.push({ id_pedido: pedido.id_pedido, tipo_pedido: '1', id_empresa: pedido.id_empresa });
      });

      this.escolherEntregador();
    },

    toggleCliente() {
      const bloqueado = !!this.selecionado.tags.find(tag => tag.id_tag === '2');
      const text = !bloqueado ?
          "Deseja bloquear este cliente?\nEle não poderá realizar novos pedidos pelo LeCard e em outros locais a impressão será marcada como suspeita."
          : "Deseja desbloquear este cliente?\nEle voltará a realizar pedidos pelo LeCard.";
      this.$swal({
        text,
        buttons: ["Não", "Sim"],
        dangerMode: true
      }).then(res => {
        if (res) {
          this.selecionado.suspeito = !bloqueado ? '1' : '0';

          if (!bloqueado) {
            this.selecionado.tags.push({ id_tag: '2', nome_tag: 'Bloqueado', color: 'danger' })

          } else {
            this.selecionado.tags = []
          }

          const dados = { id_cliente: this.selecionado.id_cliente, tags: this.selecionado.tags };

          this.$http.post('clientes/tags/' + this.token, dados).then(res => {}, res => {
            this.$swal(res.data.msg);
          });
        }
      });
    },

    loopPedidos() {
      if (this.lecardTimeOut) {
        clearTimeout(this.lecardTimeOut);
        this.lecardTimeOut = null;
      }

      if (this.isRead) {
        return;
      }

      this.lecardTimeOut = setTimeout(() => {
        if (!this.$socket.connected) {
          window.location.reload();

        } else if (!this.pesquisa.ativada) {
          this.buscarPedidosFila(null, true, () => {
            if (!this.usaNovaImpressao || !this.$store.state.impressoesKanban.length) return;

            const impressos = new Set([...this.aguardando, ...this.pedidosCache].filter(p => p.impresso).map(p => String(p.id_pedido)));
            this.$store.state.impressoesKanban.forEach(p => {
              if (impressos.has(String(p.id_pedido))) {
                this.$store.commit('finalizarImpressaoKanban', p.id_pedido);
              }
            });
          });
        }

        this.loopPedidos();
      }, (1000 * 60 * 5));
    },

    validarNotificacao() {
      if (!this.aguardando.length) {
        this.pausarNotificacao();
      }
    },

    atualizarPedidoManual(pedido) {
      this.clearPesquisa();

      if (this.usaNovaImpressao && pedido && pedido.id_pedido) {
        this.$store.state.load = false;
        this.selecionado = {
          id_pedido: pedido.id_pedido,
          id_contador: pedido.id_contador || pedido.id_pedido,
          token: pedido.token,
          updated: !!pedido.updated
        };

        this.$nextTick(() => {
          if (this.selecionado.updated) {
            this.$swal({
              text: 'Pedido editado com sucesso! Deseja imprimir ?',
              buttons: ['Não', 'Sim']
            }).then((result) => {
              if (result) {
                this.prepararImpressao();
              }
            });

          } else {
            this.$swal(`Pedido criado com sucesso!`);
            this.acompanharImpressaoPedido(pedido.id_impressao, pedido.id_pedido, pedido.ids_impressao);
          }
        });

        this.$http.get('v2/pedidos/fila', { params: { key: this.token, id_pedido: pedido.id_pedido } })
          .then(response => {
            const pedidos = (response.data || []);

            pedidos.forEach(p => {
              const dataPedido = {
                ...this.normalizarPedido(p),
                impresso: false
              };

              const index = this.pedidosCache.findIndex(x => x.id_pedido === p.id_pedido);
              if (index !== -1) this.pedidosCache.splice(index, 1);

              this.pedidosCache.unshift(dataPedido);
            });

            this.marcarPedidosImpressos();
            this.notificarSocket(this.selecionado.token, this.selecionado, true);

          }, res => {
            this.$swal(res.data.msg || 'Erro temporário');
          });
        return;
      }

      this.buscarPedidoId(pedido, (data) => {
        this.$store.state.load = false;

        if (data) {
          this.selecionado = data;
          this.$nextTick(() => {
            if (this.selecionado.update_at) {
              this.$swal({
                text: 'Pedido editado com sucesso! Deseja imprimir ?',
                buttons: ['Não', 'Sim']
              }).then((result) => {
                if (result) {
                  this.prepararImpressao();
                }
              });

            } else if (this.impressora.automatico === '1') {
              this.$swal(`Pedido criado com sucesso!`);
              this.imprimir(this.selecionado, this.impressora.nCopias);
            }
          });

          this.$http.get('v2/pedidos/fila', { params: { key: this.token, id_pedido: pedido.id_pedido } })
            .then(response => {
              const pedidos = (response.data || []);

              pedidos.forEach(p => {
                const dataPedido = {
                  ...this.normalizarPedido(p),
                  impresso: this.isElectron && this.impressora.automatico === '1'
                };

                const index = this.pedidosCache.findIndex(x => x.id_pedido === p.id_pedido);
                if (index !== -1) this.pedidosCache.splice(index, 1);

                this.pedidosCache.unshift(dataPedido);
              });

              this.notificarSocket(data.token, data, true);

            }, res => {
              this.$swal(res.data.msg || 'Erro temporário');
            });
        }
      });
    },

    escolherEntregador(pedido, despachar, drag) {
      if (!pedido) {
        if (!this.selecionados.length) {
          this.$swal("Por favor selecione pelo menos um pedido");
          return;
        }

        if (this.selecionados.find(s => s.tipo_pedido !== '1')) {
          this.$swal("Por favor, selecione somente os pedidos marcados como 'Entrega'");
          return;
        }

      } else {
        if (pedido.tipo_pedido !== '1' || (despachar && (pedido.id_entregador || !this.user.entregadores))) {
          this.acaoPedido(pedido, 3, null, drag);
          return;
        }

        if (this.emLote) {
          this.emLote = null;
          this.clearPesquisa();
        }
      }

      this.abrirModalEntregador(pedido, despachar);
    },

    abrirModalEntregador(pedido, despachar) {
      this.pedidoEntregador = pedido || null;
      this.despacharComEntregador = !!despachar;
      if (pedido && Number(pedido.id_auth_entregador)) {
        const plataforma = (this.user.entregadores || []).find(e => Number(e.id_auth) === Number(pedido.id_auth_entregador));
        this.abrirLogistica(plataforma);
      } else this.modalEntregador = true;
    },

    abrirLogistica(plataforma) {
      this.plataformaLogistica = plataforma;
      this.modalEntregador = false;
      this.modalLogistica = true;
    },

    fecharModalEntregador() {
      this.modalLogistica = false;
      this.modalEntregador = false;
      this.pedidoEntregador = null;
      this.despacharComEntregador = false;
    },

    salvarEntregador(entregador) {
      const idEntregador = entregador ? entregador.id_usuario : null;

      if (!this.pedidoEntregador) {
        this.modalEntregador = false;
        this.concluirEmMassa(this.emLote === 2 ? 3 : null, idEntregador);
        return;
      }

      const pedido = this.pedidoEntregador;
      const despachar = this.despacharComEntregador;
      const dados = {
        despachar,
        id_entregador: idEntregador,
        nome_entregador: entregador ? entregador.nome : null,
        id_empresa: pedido.id_empresa,
        id_pedido: pedido.id_pedido
      };

      this.modalEntregador = false;
      this.loadAcao = pedido.id_pedido;
      this.$http.post("delivery/pedidos/entregador/" + this.token, dados)
        .then(response => {
          this.loadAcao = false;
          if (!response.data.success) {
            this.$swal(response.data.msg || "Erro ao vincular entregador!");
            return;
          }

          this.atualizarVinculoEntregador([pedido.id_pedido], entregador, despachar);
          this.fecharModalEntregador();
        }, response => {
          this.loadAcao = false;
          this.$swal(response.data && response.data.msg ? response.data.msg : 'Erro temporário');
        });
    },

    atualizarSolicitacaoEntregador({ ids_pedidos, entregador, despachar }) {
      this.atualizarVinculoEntregador(ids_pedidos, entregador, despachar);
    },

    atualizarVinculoEntregador(idsPedidos, entregador, despachar) {
      idsPedidos.forEach(idPedido => {
        const pedido = this.encontrarPedido(idPedido);
        if (!pedido) return;

        pedido.id_entregador = entregador ? entregador.id_usuario : null;
        pedido.nome_entregador = entregador ? entregador.nome : null;
        this.$set(pedido, 'id_auth_entregador', entregador && entregador.id_auth ? entregador.id_auth : null);
        if (!entregador) pedido.status_entrega = null;
        if (despachar) this.atualizarEntregador(pedido);
      });
    },

    atualizarEntregador(pedido) {
      this.statusListaPedidos(3, pedido.id_pedido);
      this.notificarSocket(pedido.token, pedido);

      if (this.pesquisa.ativada && this.pesquisa.filtro === '1') {
        this.$nextTick(() => {
          this.$helpers.focusElement( 'pesquisarPedido');
        });
      }
    },

    togglePilotoAutomatico() {
      if (this.loadPedidos) {
        return;
      }

      if (!this.pilotoAutomatico) {
        this.$swal({
          text: "Atenção, você ainda precisará ficar atento se sua impressora está funcionando para imprimir os pedidos.",
          buttons: ["Cancelar", "Ativar"],
          dangerMode: true
        }).then(res => {
          if (res) {
            localStorage.setItem('pilotoAutomatico', '1');
            this.$store.state.pilotoAutomatico = true;
            this.buscarPedidosFila(1);
          }
        });

      } else {
        localStorage.setItem('pilotoAutomatico', '0');
        this.$store.state.pilotoAutomatico = false;
      }
    },

    onDrop(evt, list) {
      const id_pedido = evt.dataTransfer.getData('id_pedido');

      if (id_pedido) {
        const pedido = this.encontrarPedido(id_pedido);

        if (pedido && (parseInt(pedido.status) + 1) === list && !this.emLote) {
          if (list === 3) {
            this.escolherEntregador(pedido, true, true);

          } else {
            this.acaoPedido(pedido, list, null, true);
          }
        }
      }
    },

    msgIfood() {
      this.$swal("Certifique-se de que o Gestor Principal esteja sempre aberto para garantir que os pedidos do iFood sejam sincronizados.");
    },

    editarPedido(pedido) {
      const integracoes = {
        '6': 'iFood',
        '7': 'UaiRango',
        '9': 'Keeta',
        '10': 'AiqFome',
        '11': '99Food'
      };

      if (pedido.id_integrador_pedido || integracoes[pedido.origin]) {
        const plataforma = integracoes[pedido.origin] || pedido.integracao?.plataforma || 'integração';
        this.$swal(`Não é possível editar pedidos importados da plataforma ${plataforma}`);
        return;
      }

      this.$store.state.load = true;
      this.$http.get(`delivery/pedido/editar/${this.token}/${pedido.id_pedido}`)
        .then(res => {
          this.$store.state.load = false;

          if (res.data && res.data.id_pedido) {
            this.fecharModalPedido();
            this.$refs.manual.editarPedidoManual(res.data);
          }

        }, res => {
          console.log(res);
          this.$store.state.load = false;
          this.$swal(res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    encontrarPedido(id_pedido) {
      const id = id_pedido.toString();

      return (
          this.aguardando.find(p => p.id_pedido === id) ||
          this.pedidosCache.find(p => p.id_pedido === id) ||
          this.pedidos.find(p => p.id_pedido === id) ||
          null
      );
    },

    normalizarPedido(pedido) {
      const hoje = this.$dayjs().startOf('day');
      const agora = this.$dayjs();

      const diaAgendado = pedido.data_agendamento ? this.$dayjs(pedido.data_agendamento).startOf('day') : null;
      const previsao = (pedido.status === '2' && pedido.previsao) ? this.$dayjs(pedido.previsao) : null;
      const nome_cliente = (pedido.tipo_cliente === '2' ? pedido.obs_pedido : pedido.nome_cliente) || '';

      return {
        ...pedido,
        nome_cliente,
        _previsao: pedido.previsao ? this.$dayjs(pedido.previsao).valueOf() : null,
        _nome_cliente: nome_cliente.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase(),
        _endereco: pedido.obs_entrega && pedido.tipo_pedido === '1'
            ? pedido.obs_entrega.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            : '',
        _agendado: !!diaAgendado && diaAgendado.isAfter(hoje),
        _atrasado: !!previsao && previsao.isBefore(agora),
      };
    }
  },

  mounted() {
    if (!this.token) {
      this.logout(true);
      return;
    }

    this.pesquisa.key = this.token;
    this.multiple = this.empresas.length > 1;
    this.isRead = this.$store.state.is_comanda || this.$store.state.isReadOnly;
    this.showPiloto = this.printServer || localStorage.getItem('showPiloto') === '1';

    if (!this.isRead) {
      this.buscarPedidosFila(null, true);
      this.loopPedidos();
    }

    this.ifood = !!(this.integracoes.find(i => i.plataforma === '2' && i.fg_ativo === '1'));

    this.intervalAgr = setInterval(() => {
      this.agora = this.$dayjs();
    }, 60000);
  },

  created() {
    this.$parent.$on("abrirPedidos", () => {
      if (this.isRead) {
        this.buscarPedidosFila(null, false, () => {
          this.$helpers.focusElement('pesquisarPedido');
        });
      }
    });
  },

  beforeDestroy() {
    clearTimeout(this.lecardTimeOut);
    clearTimeout(this.paTimeOut);
    clearInterval(this.intervalAgr);
  },

  computed: {
    impressoesKanbanConfirmadas() {
      return this.$store.state.impressoesKanban.filter(p => p.confirmado).map(p => p.id_pedido);
    },

    podeConfirmarCancelamento() {
      if (!this.cancelamento.tipo_cancelamento) {
        return false;
      }

      return !this.cancelamento.requer_observacao || this.cancelamento.obs_cancelamento.trim().length > 0;
    },

    empresas() {
      return this.$store.state.empresas
    },

    user() {
      return this.$store.state.dataUser
    },

    canPlay() {
      return this.$store.state.canPlay
    },

    master() {
      return this.$store.state.dataUser.master
    },

    impressora() {
      return this.$store.state.impressora
    },

    configImpressao() {
      return this.$store.state.configImpressao
    },

    usaNovaImpressao() {
      return Number(this.configImpressao.migrado_legado || 0) === 1;
    },

    pilotoAutomatico() {
      return this.$store.state.pilotoAutomatico
    },

    printServer() {
      return this.$store.state.printServer
    },

    printLocal() {
      return this.$store.state.printLocal
    },

    bell() {
      return this.$store.state.bell
    },

    integracoes() {
      return this.$store.state.integracoes
    },

    ifoodAtivo() {
      return this.$store.state.ifoodAtivo
    },

    statusIfood() {
      return this.$store.state.statusIfood;
    },

    preparando() {
      return this.filtrarComputed('2').filter(p => !p._agendado);
    },

    despachados() {
      return this.filtrarComputed('3');
    },

    agendados() {
      return this.filtrarComputed('2').filter(p => p._agendado);
    },
  },

  watch: {
    impressoesKanbanConfirmadas: {
      immediate: true,
      handler() {
        this.marcarPedidosImpressos();
      }
    },

    canPlay(val) {
      if (val) {
        this.tocarNotificacao();
      }
    }
  },

  sockets: {
    connect() {
      const buscar = !this.isRead && this.token && this.$store.state.isReady && !this.is_mobile;

      if (buscar) {
        this.buscarPedidosFila(1, true);
      }
    },

    delivery_order() {
      if (this.isRead || this.paLoad) {
        return;
      }

      if (!this.socketTimeout) {
        this.socketTimeout = setTimeout(() => {
          this.loadAguardando = true;
          this.buscarPedidosFila(1);
          this.socketTimeout = null;
        }, 10000);
      }
    },

    order_courier(data) {
      if (this.isRead || !data || !Array.isArray(data.ids_pedidos) || data.entregador !== null) {
        return;
      }

      this.atualizarVinculoEntregador(data.ids_pedidos.map(String), null, false);
    },

    notification(data) {
      if (this.isRead || this.paLoad) {
        return;
      }

      if (data && data.session && (data.session !== this.$store.state.session)) {
        if (data.pedido_manual) {
          if (!this.sincronizarMapaAberto()) {
            this.buscarPedidosFila();
          }

          return;
        }

        if (data.id_pedido && data.status) {
          const status = parseInt(data.status);
          const id_pedido = data.id_pedido.toString();
          this.statusListaPedidos(status, id_pedido, data.id_comanda);
          this.validarNotificacao();

          if (status === 2) {
            this.sincronizarMapaAberto();
          }
        }
      }
    },

    geo_localizacao(data) {
      this.$refs.mapa.setRastreamento(data);
    },
  },

  filters: {
    status(s) {
      switch (s) {
        case "1":
          return "Pendente";
        case "2":
          return "Pago";
        case "5":
          return "Reembolsado";
        default:
          return s;
      }
    }
  }
}
</script>

<style scoped>
.kanban-coluna {
  background-color: #FFFFFF;
  border: 1px solid #e9ecef;
  margin-bottom: 6px;
  border-radius: 8px;
  overflow: hidden;
}

.kanban-col-header {
  padding: 7px 12px;
  font-size: 0.8em;
  color: #FFFFFF;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
}

.kanban-col-body {
  height: calc(100vh - 182px);
  overflow: auto;
  padding-bottom: 6px;
}

.checkbox-label {
  display: inline-flex;
  align-items: center;
}

.checkbox-header {
  accent-color: #fff;
  cursor: pointer;
}

.btn-piloto {
  padding: 4px 12px;
  display: inline-block;
  border-radius: 18px;
}

.btn-piloto:hover {
  text-decoration: none;
}

.modal-kanban .modal-pdv-content {
  margin-top: 72px;
  height: calc(100vh - 110px);
  border: 12px;
}

.container-kanban {
  padding-right: 12px;
  padding-left: 12px;
}

.pd {
  height: 100%;
}

.pd-header {
  padding: 6px 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pd-content {
  padding: 18px 12px 12px;
  height: calc(100% - 118px);
  overflow: auto;
}

.pd-bottom {
  padding: 12px 12px 0;
}

.modal-outros {
  position: absolute;
  top: 42px;
  right: 4px;
  z-index: 99;
  text-align: left;
}

.modal-outros .card {
  padding: 4px 12px;
  max-width: 250px;
  max-height: 322px;
  overflow-y: auto;
}

.modal-outros .outros-item {
  cursor: pointer;
  padding: 8px 0;
  border-bottom: 1px solid var(--light);
  text-decoration: none;
  color: var(--dark);
  font-size: 0.9em;
}

.modal-outros .outros-item:last-child {
  border-bottom: none;
}

.new {
  position: absolute;
  font-size: 0.5em;
  font-weight: bold;
  background-color: var(--warning);
  border-radius: 4px;
  top: 5px;
  right: 10px;
  padding: 0 2px;
}

@media (min-width: 992px) {
  .modal-kanban .modal-pdv-content.is-modal {
    margin-top: 48px;
    max-width: 420px;
  }
}

@media (max-width: 991px) {
  .kanban-coluna {
    display: none;
    margin-bottom: 12px;
  }

  .kanban-coluna.aberto {
    display: block;
  }

  .kanban-col-body {
    height: auto;
    min-height: 520px;
  }
}

@media (max-width: 767px) {
  .kanban-coluna {
    display: none;
    margin-bottom: 82px;
  }
}
</style>
